import React from 'react';
import Search from '../../Components/Search';
import ListView from './ListView';

const Customers = () => {
    return <Search hasConditionsFilter={filterSearchConditions} persist="customers-search">
        <ListView />
    </Search>
}

const filterSearchConditions = (conditions) => {
    if (conditions.hasUnreadMessages === 'Either') {
        delete conditions.hasUnreadMessages;
    }
    if (conditions.balance === 'Any') {
        delete conditions.balance;
    }
    if (conditions.hasLocation === 'Either') {
        delete conditions.hasLocation;
    }
    if (conditions.type === 'Either') {
        delete conditions.type;
    }
    if (conditions.roundId === 'no-round') {
        delete conditions.roundId;
    }

    return conditions;
}

export default Customers;
